var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3707:31711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1943 6.31852C8.90945 5.60341 10.1369 6.11619 10.1369 7.12316C10.1369 7.53135 10.4678 7.86224 10.876 7.86224C11.2841 7.86224 11.615 7.53135 11.615 7.12316C11.615 5.9373 10.8217 4.93384 9.73803 4.61406V4.11994C9.73803 3.71176 9.40713 3.38086 8.99894 3.38086C8.59076 3.38086 8.25986 3.71176 8.25986 4.11994V4.61287C7.00111 4.98156 6.18882 6.24271 6.47594 7.56862C6.65265 8.38477 7.2178 9.0624 7.98767 9.38129L9.44457 9.98473C10.1184 10.2639 10.3201 11.1287 9.83256 11.6518C9.13314 12.4014 7.86097 11.9104 7.86097 10.8772C7.86097 10.469 7.53008 10.1381 7.12189 10.1381C6.71371 10.1381 6.38281 10.469 6.38281 10.8772C6.38281 12.0319 7.14604 13.0613 8.25983 13.3858V13.8804C8.25983 14.2886 8.59073 14.6195 8.99891 14.6195C9.40709 14.6195 9.73799 14.2886 9.73799 13.8804V13.3847C10.1503 13.2646 10.5281 13.0445 10.8391 12.7367C12.1238 11.4659 11.6639 9.30408 10.0102 8.61909L8.55328 8.01565C7.87188 7.7334 7.66723 6.84654 8.1943 6.31852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3625 2.63745C11.8462 -0.878905 6.15432 -0.879397 2.63747 2.63745C-0.878891 6.15381 -0.879419 11.8457 2.63747 15.3625C6.15382 18.8789 11.8456 18.8794 15.3625 15.3625C18.8789 11.8462 18.8795 6.15434 15.3625 2.63745ZM9.00001 16.5198C4.85357 16.5198 1.48018 13.1464 1.48018 9.00004C1.48018 4.85363 4.85357 1.4802 9.00001 1.4802C13.1465 1.4802 16.5199 4.8536 16.5199 9.00004C16.5199 13.1465 13.1465 16.5198 9.00001 16.5198Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3707:31711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.ed7425669aeddc9fadaf3da04eda6acf.svg";
export { ForwardRef as ReactComponent };